const status = {
  title: 'Air conditioning status',
    meta: [],
}

const type = {
  title: 'Air conditioning type',
  meta: [
    {
      key: 'manufacturer',
      label: 'Manufacturer',
      type: 'text',
    },
    {
      key: 'unit_type',
      label: 'Air conditioning unit Type',
      type: 'text',
    },
    {
      key: 'cooling_capacity',
      label: 'Cooling capacity (kW)',
      type: 'double',
    },
    {
      key: 'heating_capacity',
      label: 'Heating capacity (kW)',
      type: 'double',
    },
    {
      key: 'freon_type',
      label: 'Freon type',
      type: 'text',
    },
    {
      key: 'air_flow_rate',
      label: 'Air flow rate (m3/h)',
      type: 'double',
    },
    {
      key: 'sound_pressure',
      label: 'Sound pressure (dB)',
      type: 'double',
    },
    {
      key: 'l_w_h',
      label: 'L x W x H (cm)',
      type: 'text',
    },
    {
      key: 'weight',
      label: 'Weight (kg)',
      type: 'double',
    },
    {
      key: 'power_input',
      label: 'Power input (1F/3F)',
      type: 'text',
    },
    {
      key: 'equipment_comment',
      label: 'Equipment Comment',
      type: 'multiline',
    },
  ],
}

export default {
  type: type,
  status: status,
}
